import { useQuery } from '@tanstack/react-query'
import { CATEGORIES, EXPENSES } from '../../constants/endpoints'
import { getCategories } from '../../utils/getCategories'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useExpensesCategoriesQuery = ({
  enabled,
}: {
  enabled: boolean
}) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [EXPENSES, CATEGORIES, userId],
    queryFn: getCategories,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
